import React from 'react'
import { font } from '@chegg-ui/theme'
import BackLink from '@chegg-wt/core/components/BackLink'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state/types'
import { currentUrlStyleNameSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { updateMessagingFlagSelector } from '@chegg-wt/core/state/app/selectors'
import { styleHomeSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { Config } from '@chegg-wt/core/config'
import { CM } from '@chegg-wt/core/constants/site'
import { SubHeadingBCRest } from '../BrandConsolidation'
import { PageHeaderWrapper } from '../Layouts/styled'
import * as Styled from './styled'
import { SiteAndStyleDetailProps } from './types'

export const SourceTypeSelectionTop: React.FC<SiteAndStyleDetailProps> = ({
  styleHome,
  initialUrlStyleName,
  urlStyleName,
  isDefaultStyle,
  showSubHeaderText,
  updateMessagingFeatureEnabled,
}) => {
  const { appName } = Config
  return (
    <>
      <BackLink />
      <PageHeaderWrapper>
        <Styled.Header>
          <Styled.HeaderText headerWeight={font.weight.bold} id="--source-type-label">
            {`${
              isDefaultStyle || (!initialUrlStyleName && !isDefaultStyle)
                ? ''
                : `${urlStyleName || initialUrlStyleName} `
            }Citation Generator`}
          </Styled.HeaderText>
        </Styled.Header>
        {(appName !== CM || updateMessagingFeatureEnabled) && <SubHeadingBCRest />}
      </PageHeaderWrapper>
      {showSubHeaderText && !styleHome ? (
        <Styled.SubHeaderText>
          Start by choosing your source. You will be able to select a style later.
        </Styled.SubHeaderText>
      ) : null}
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  urlStyleName: currentUrlStyleNameSelector(state),
  styleHome: styleHomeSelector(state),
  updateMessagingFeatureEnabled: updateMessagingFlagSelector(state),
})

export default connect(mapStateToProps)(SourceTypeSelectionTop)
